import * as Sentry from '@sentry/react';
import { FC, Fragment, useEffect, useState } from 'react';

import { useI18nContext } from '../../../hooks/contexts/i18n.context';
import { useModalContext } from '../../../hooks/contexts/modal.context';
import { useUserContext } from '../../../hooks/contexts/user.context';
import { logger } from '../../../utils/logger';
import AwaitingResponse from '../AlertModalAwaitingResponse';
import * as Styles from './styles.alertModal';

type AlertModalContentProps = {
  isMandatory: boolean;
  associateTheTicketForMe: () => string
}

export const AlertModalContent: FC<AlertModalContentProps> = ({ isMandatory, associateTheTicketForMe }) => {
  const [awaiting, setAwaiting] = useState(false);

  const { translate } = useI18nContext();
  const { rfData, rFCheckWasSuccessful } = useUserContext();
  const { toggleModal } = useModalContext();

  const onboardingUrl = rfData?.onboarding_url;
  const isOnboardingReady = Boolean(onboardingUrl);

  useEffect(() => {
    if (rFCheckWasSuccessful) {
      associateTheTicketForMe();
    }
  }, [rFCheckWasSuccessful]);

  const handleRegisterNow = () => {
    if (!onboardingUrl) {
      Sentry.addBreadcrumb({
        category : 'facial-recognition',
        level : 'warning',
        message : 'register-now clicked without onboarding_url',
        data : { hasRfData : Boolean(rfData) },
      });
      logger.warn('AlertModalContent: register-now clicked without onboarding_url', {
        hasRfData : Boolean(rfData),
      });
      return;
    }
    setAwaiting(true);
    window.open(onboardingUrl, '_blank');
  };

  return (
    <Styles.WrapperAlert>
      {
        awaiting ? (
          <AwaitingResponse />
        ) : (
          <Fragment>
            <Styles.ContainerText>
              <Styles.TextInfo>
                {translate(['INFORMATION', 'FACIAL_BIOMETRY_REGISTRATION_BENEFITS'])}
              </Styles.TextInfo>
              <Styles.TextInfo>
                {translate(['INFORMATION', 'ONE_TIME_REGISTRATION_BENEFIT'])}
              </Styles.TextInfo>
            </Styles.ContainerText>
            <Styles.WrapperButton>
              {!isMandatory && (
                <Styles.Button
                  $type='latter'
                  onClick={() => {
                    associateTheTicketForMe();
                    toggleModal({ open : false });
                  }
                  }
                >
                  {translate(['INFORMATION', 'REGISTER_LATER'])}
                </Styles.Button>)}
              <Styles.Button
                $type='now'
                disabled={!isOnboardingReady}
                onClick={handleRegisterNow}
              >
                {translate(['INFORMATION', 'REGISTER_NOW'])}
              </Styles.Button>
            </Styles.WrapperButton>
          </Fragment>
        )
      }
    </Styles.WrapperAlert>
  );
};

